<template>
  <v-card>
    <v-card-text>
      
      <v-form
        ref="ProductPriceForm"
        v-model="ProductPriceValid"
        v-if="supplierProductId"
      >
        <v-row>
                <span v-if="saleUnitText==null" class="mb-3 text-danger">بدلیل  مشخص نبودن واحد شمارش برای ثبت قیمت، فعلاً امکان ثبت قیمت مقدور نیست، لطفاً با پشتیبانی تکصان تماس بگیرید</span>

          <v-data-table
            :items="productPrice.priceItems"
            :headers="priceItemHeaders"
            class="elevation-1"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:[`item.operation`]="{ item }">
              <v-btn
                icon
                small
                color="primary"
                @click="deletePriceItem(item)"
                v-if="itemIsTheFirstOne(item)"
              >
                <v-icon color="blue" small>mdi-delete</v-icon></v-btn
              >
            </template>
          </v-data-table>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              type="number"
              dense
              label=" حداقل سفارش *"
              required
              :rules="[(v) => !!v || 'وارد کردن حداقل سفارش الزامی میباشد']"
              v-model="minimumOrderVolume"
              class="mt-1"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              dense
              label=" توضیحات سفارش "
              maxlength="120"
              v-model="productPrice.description"
              class="mt-1"
              outlined
              max-height="15"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="priceItem.priceRange"
              item-value="title"
              item-text="displayName"
              placeholder="نوع قیمت انتخاب شود "
              outlined
              label="نوع قیمت    "
              dense
              required
              :items="periceRanges"
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              dense
              :label="'از'+ saleUnitText +'*'"
               :required="(priceItem.priceRange == 'Middle') || (priceItem.priceRange == 'Start')"
              :rules="[(v) => !!v || 'وارد کردن حداقل سفارش الزامی میباشد']"
              v-model="priceItem.fromQty"
              class="mt-1"
              type="number"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              dense
               :label="'تا'+ saleUnitText +'*'"
              :required="priceItem.priceRange == 'Middle'"
              v-model="priceItem.toQty"
              class="mt-1"
              type="number"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              dense
              :label="('ریال' + priceItem.price) | priceSplitter"
           
              v-model="priceItem.price"
              class="mt-1"
              type="number"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn
              :disabled="saleUnitText==null"
              class="mx-2"
              small
              fab
              dark
              color="indigo"
              @click="addPriceItem()"
            >
              <v-icon dark> mdi-plus </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer> </v-spacer>

      <v-btn :disabled="saleUnitText==null"  @click="SavePrice()" color="primary"
        >ذخیره</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const supplierProductRepository = RepoFactory.get('supplierProduct');
import Helper from '@/core/helpers';
export default {
  components: {},
  props: {
    supplierProductId: {
      default: null,
      type: String,
    },
    minimumOrderVolume: {
      default: null,
      type:Number
    },
     selectedSupplierProduct: {
      default: null,
      type:Object,
    },
  },
  data() {
    return {
      ProductPriceValid: true,
      productPrice: {
        supplierProductId: null,
        minimumOrderVolume: null,
        description: null,
        priceItems: [],
      },
      priceItem: {
        priceRange: 'Start', //[ Start, Middle, End ]
        fromQty: '',
        toQty: '',
        price: '',
      },
      periceRanges: [
        {
          title: 'Start',
          displayName: 'حداقل خرید',
        },
        {
          title: 'Middle',
          displayName: 'خرید متوسط  ',
        },
        {
          title: 'End',
          displayName: 'خرید عمده',
        },
      ],
      priceItemHeaders: [
        { sortable: true, text: 'نوع فروش ', value: 'priceRange' },
        { sortable: true, text: 'از تعداد', value: 'fromQty' },
        { sortable: true, text: 'تا تعداد', value: 'toQty' },
        { sortable: true, text: 'قیمت- ریال  ', value: 'price' },
        {
          text: 'حذف',
          value: 'operation',
          align: 'left',
        },
      ],
    };
  },
  created() {
     
  },
  computed: {
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    saleUnitText() {
      return this.selectedSupplierProduct?.measurementUnitDisplayText;
    }
  },
  methods: {
    itemIsTheFirstOne(item) {
      let finded = this.productPrice.priceItems.findIndex(
        (el) => el.priceRange == item.priceRange && el.fromQty == item.fromQty
      );
      if (finded == 0) {
        return true;
      } else {
        return false;
      }
    },
    clrearPriceItem() {},
    deletePriceItem(item) {
      let finded = this.productPrice.priceItems.findIndex(
        (el) => el.priceRange == item.priceRange && el.fromQty == item.fromQty
      );
      this.productPrice.priceItems.splice(finded, 1);
    },
    addPriceItem() {
      let startvalue = parseInt(this.priceItem.fromQty==''? '0':this.priceItem.fromQty);
      let pricevalue = parseInt(this.priceItem.price==''? '0':this.priceItem.price);

      if (pricevalue == 0 || pricevalue < 0) {
        alert('قیمت ثبت شده معتبر نیست');
        return;
      }
      if (startvalue == 0 || startvalue < 0) {
        alert('تعداد شروع قیمت باید مقدار داشته باشد');
        return;
      }
      let param = {
        priceRange: this.priceItem.priceRange,
        fromQty: this.priceItem.fromQty,
        toQty: this.priceItem.toQty,
        price: this.priceItem.price,
      };

      //If the first item is adding it shoul be from type start
      if (
        this.productPrice.priceItems.length == 0 &&
        this.priceItem.priceRange != 'Start'
      ) {
        alert('ابتدا باید از خرده فروشی قیمت گذاری کنید');
        return;
      }
      if (
        this.productPrice.priceItems.length == 1 &&
        parseInt(this.productPrice.priceItems[0].toQty) == 0
      ) {
        alert(
          'با توجه بخ نحوه قیمت گذاری قبلی، امکان افزودن شرایط قیمت جدید نیست در صورت نیاز قبلی را حذف و مجدداً ثبت کنید'
        );
        return;
      }
      if (this.priceItem.priceRange == 'Start') {
        //Start qty and minimum order num must be equal
        if (this.priceItem.fromQty != this.minimumOrderVolume) {
          alert(
            'مقدار حداقل سفارش و مقدار شروع تعداد در شروع قیمت باید برابر باشند'
          );
          return;
        }
        let findedIndexForPricerange = this.productPrice.priceItems.findIndex(
          (el) => el.priceRange == 'Start'
        );

        if (findedIndexForPricerange != -1) {
          alert('قیمت شروع  فقط یکبار ثبت شود');
          return;
        }
      }
      if (this.priceItem.priceRange == 'End') {
        let findedIndexForPricerange = this.productPrice.priceItems.findIndex(
          (el) => el.priceRange == 'End'
        );
        if (findedIndexForPricerange != -1) {
          alert('قیمت پایان  فقط یکبار ثبت شود');
          return;
        }
      }
      this.productPrice.priceItems.push(param);
      this.priceItem.fromQty = parseInt(this.priceItem.toQty) + 1;
      if (this.priceItem.priceRange == 'Start') {
        this.priceItem.priceRange = 'Middle';
        this.priceItem.price = 0;
      }
      this.priceItem.price = 0;
    },
    closePriceModal() {
      this.$emit('closePriceModal');
    },
    SavePrice() {
      if (this.$refs.ProductPriceForm.validate()) {
        const loader = this.$loading.show();
        this.productPrice.supplierProductId = this.supplierProductId;
        this.productPrice.minimumOrderVolume = this.minimumOrderVolume;
        supplierProductRepository
          .registerSupplierProductPrice(
            this.productPrice,
            this.productBaseUrl,
            {
              MerchantId: this.merchantId,
            }
          )
          .then(() => {
            this.closePriceModal();
            this.$dialog.message.success('قیمت با موفقیت ثبت شد. ', {
              position: 'top-left',
            });
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
          })
          .finally(() => loader.hide());
      }
      else {
        alert("اطلاعات کامل ثبت شود")
      }
    },
    fillValueInput(data) {
      if (data) {
      }
    },
  },
  watch: {
    minimumOrderVolume(value) {
     // alert(value)
      this.productPrice.minimumOrderVolume=value
    },
    'priceItem.priceRange': function (value) {
       
      if (value = "End") {
        this.priceItem.toQty = 0;
      }
    }
  }
};
</script>

<style></style>
